<template>
    <div class="wrapper flex flex-column justify-content-center align-items-center p-4 w-full h-full">
        <CustomBreadcrumb class="flex align-self-start"
            :items="[{ label: 'Profile Settings' }, { label: 'Profile' }]" />
        <span class="H6-Medium block text-center mt-6">Add details about your institution</span>
        <form class="md:col-11 md:p-5 mt-4" @submit.prevent="handleSubmit">
            <div class="w-full col-12 grid">

                <div class="col-12 md:col-6 md:pr-3">
                    <div class="flex flex-column gap-2 pt-2">
                        <label for="instituteName" class="Lable">Institution Name</label>
                        <InputText id="instituteName" v-model="form.instituteName" class="w-full" variant="filled"
                            size="small" required :disabled="loading" />
                    </div>
                </div>

                <div class="col-12 md:col-6 md:pr-3">
                    <div class="flex flex-column gap-2 pt-2">
                        <label for="brc" class="Lable">BRC</label>
                        <InputText id="brc" v-model="form.brc" class="w-full" variant="filled" size="small" required
                            :disabled="loading" />
                    </div>
                </div>

                <div class="col-12 md:col-6 md:pr-3">
                    <div class="flex flex-column gap-2 pt-2">
                        <label for="address" class="Lable">Address</label>
                        <InputText id="address" v-model="form.address" class="w-full" variant="filled" size="small"
                            required :disabled="loading" />
                    </div>
                </div>
                <div class="col-12 md:col-6 md:pr-3">
                    <div class="flex flex-column gap-2 pt-2">
                        <label for="startYear" class="Lable">Started year</label>
                        <InputText id="startYear" v-model.number="form.startedYear" class="w-full" type="number"
                            :min="1900" :max="currentYear" variant="filled" size="small" required :disabled="loading" />
                    </div>
                </div>

                <div class="col-12">
                    <div class="flex flex-column gap-2 pt-2">
                        <label for="bio" class="block">Bio</label>
                        <Textarea id="bio" v-model="form.bio" rows="4" class="w-full" variant="filled" size="small"
                            :disabled="loading" />
                    </div>
                </div>

                <div class="flex flex-column pt-4">
                    <Button type="submit" label="Save" class="yellow-button w-full md:w-auto"
                        :disabled="!isFormValid || loading" size="small" :loading="loading" />
                </div>
            </div>
        </form>

    </div>
</template>

<script setup>
import { ref, defineProps, computed, defineEmits, watch, onMounted } from "vue";
import CustomBreadcrumb from '@/components/CustomBreadcrumb.vue';
import { Button, InputText, Textarea } from "primevue";


const emit = defineEmits(["update-profile"]);

const props = defineProps({
    profile: {
        type: Object,
        required: true
    },
    loading: {
        type: Boolean,
        default: false
    }
});

const currentYear = new Date().getFullYear();

const form = ref({
    instituteName: "",
    brc: "",
    address: "",
    startedYear: null,
    bio: "",
});

const isFormValid = computed(() => {
    return (
        form.value.instituteName.trim() !== "" &&
        form.value.brc.trim() !== "" &&
        form.value.address.trim() !== "" &&
        form.value.startedYear !== null &&
        !isNaN(form.value.startedYear) &&
        String(form.value.startedYear).length === 4 &&
        form.value.startedYear >= 1900 &&
        form.value.startedYear <= currentYear
    );
});

function loadFormData() {
    form.value.instituteName = props.profile?.username || "";
    form.value.brc = props.profile?.BRC || "";
    form.value.address = props.profile?.address || "";
    form.value.startedYear = props.profile?.startedYear ? Number(props.profile.startedYear) : new Date().getFullYear();
    form.value.bio = props.profile?.bio || "";
}

async function handleSubmit() {
    if (!isFormValid.value) return;

    const payload = {
        instituteName: form.value.instituteName.trim(),
        BRC: form.value.brc.trim(),
        address: form.value.address.trim(),
        startedYear: String(form.value.startedYear),
        bio: form.value.bio.trim()
    };
    emit("update-profile", payload);
}

onMounted(() => {
    loadFormData();
});

watch(() => props.profile, () => {
    loadFormData();
}, { deep: true });
</script>

<style scoped></style>